/**
 * Greek Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const el: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Πίνακας ελέγχου',
  'nav.funds': 'Ταμεία',
  'nav.investments': 'Επενδύσεις',
  'nav.investees': 'Αποδέκτες επενδύσεων',
  'nav.esg': 'ESG Αξιολόγηση',
  'nav.compliance': 'Συμμόρφωση',
  'nav.reports': 'Αναφορές',
  'nav.settings': 'Ρυθμίσεις',
  'nav.users': 'Χρήστες',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Δείκτες',
  'nav.taxonomy': 'Ταξινομία ΕΕ',
  'nav.filings': 'Υποβολές',
  'nav.calendar': 'Ημερολόγιο',
  'nav.submit': 'Υποβολή δεδομένων',
  'nav.submissions': 'Οι υποβολές μου',
  'nav.benchmarks': 'Δείκτες αναφοράς',
  'nav.messages': 'Μηνύματα',
  'nav.portfolio': 'Χαρτοφυλάκιο',
  'nav.performance': 'Απόδοση ταμείων',
  'nav.esgSummary': 'ESG Σύνοψη',
  'nav.pipeline': 'Αγωγός',
  'nav.dueDiligence': 'Due Diligence',
  'nav.impact': 'Δείκτες αντίκτυπου',
  'nav.sdg': 'Χαρτογράφηση ΣΒΑ',
  'nav.audit': 'Ίχνος ελέγχου',
  'nav.snapshots': 'Στιγμιότυπα δεδομένων',
  'nav.knowledgeGraph': 'Γράφος γνώσης',
  'nav.geographic': 'Γεωγραφικό',
  'nav.bi': 'BI Studio',
  'nav.ai': 'AI Βοηθός',
  'nav.tasks': 'Εργασίες',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Ρυθμιστική παρακολούθηση',

  // Common Actions
  'action.create': 'Δημιουργία',
  'action.edit': 'Επεξεργασία',
  'action.delete': 'Διαγραφή',
  'action.save': 'Αποθήκευση',
  'action.cancel': 'Ακύρωση',
  'action.submit': 'Υποβολή',
  'action.approve': 'Έγκριση',
  'action.reject': 'Απόρριψη',
  'action.download': 'Λήψη',
  'action.export': 'Εξαγωγή',
  'action.import': 'Εισαγωγή',
  'action.filter': 'Φίλτρο',
  'action.search': 'Αναζήτηση',
  'action.refresh': 'Ανανέωση',
  'action.close': 'Κλείσιμο',
  'action.back': 'Πίσω',
  'action.next': 'Επόμενο',
  'action.previous': 'Προηγούμενο',
  'action.viewAll': 'Προβολή όλων',
  'action.viewDetails': 'Προβολή λεπτομερειών',
  'action.generate': 'Δημιουργία',
  'action.signOut': 'Αποσύνδεση',
  'action.addNew': 'Προσθήκη νέου',
  'action.invite': 'Πρόσκληση',

  // Statuses
  'status.draft': 'Πρόχειρο',
  'status.submitted': 'Υποβλήθηκε',
  'status.validated': 'Επικυρώθηκε',
  'status.approved': 'Εγκρίθηκε',
  'status.rejected': 'Απορρίφθηκε',
  'status.pending': 'Εκκρεμεί',
  'status.inProgress': 'Σε εξέλιξη',
  'status.overdue': 'Εκπρόθεσμο',
  'status.compliant': 'Συμμορφούμενο',
  'status.filed': 'Υποβλήθηκε',
  'status.active': 'Ενεργό',
  'status.inactive': 'Ανενεργό',
  'status.closed': 'Κλειστό',
  'status.fundraising': 'Συγκέντρωση κεφαλαίων',
  'status.investing': 'Επένδυση',
  'status.harvesting': 'Συγκομιδή',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Επισκόπηση χαρτοφυλακίου',
  'dashboard.complianceStatus': 'Κατάσταση συμμόρφωσης',
  'dashboard.collectionProgress': 'Πρόοδος συλλογής',
  'dashboard.activityFeed': 'Δραστηριότητα',
  'dashboard.quickActions': 'Γρήγορες ενέργειες',
  'dashboard.investmentPipeline': 'Αγωγός επενδύσεων',
  'dashboard.totalFunds': 'Σύνολο ταμείων',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Ενεργές επενδύσεις',
  'dashboard.totalInvestees': 'Αποδέκτες επενδύσεων',
  'dashboard.recentActivity': 'Πρόσφατη δραστηριότητα',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Σύνολο δεσμεύσεων',
  'lp.capitalCalled': 'Κληθέν κεφάλαιο',
  'lp.distributed': 'Διανεμηθέν',
  'lp.netPosition': 'Καθαρή θέση',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Απόδοση ταμείων',
  'lp.esgSummary': 'ESG Σύνοψη',
  'lp.reportLibrary': 'Βιβλιοθήκη αναφορών',
  'lp.taxonomyAligned': 'Ευθυγραμμισμένο με ταξινομία',
  'lp.paiCoverage': 'PAI Κάλυψη',
  'lp.portfolioPerformance': 'Απόδοση χαρτοφυλακίου LP',

  // Fund Labels
  'fund.name': 'Όνομα ταμείου',
  'fund.code': 'Κωδικός ταμείου',
  'fund.vintage': 'Έτος ίδρυσης',
  'fund.size': 'Μέγεθος ταμείου',
  'fund.targetSize': 'Στόχος μεγέθους',
  'fund.currency': 'Νόμισμα',
  'fund.strategy': 'Στρατηγική',
  'fund.status': 'Κατάσταση',
  'fund.sfdrCategory': 'SFDR Κατηγορία',
  'fund.geographyFocus': 'Γεωγραφική εστίαση',
  'fund.sectorFocus': 'Τομεακή εστίαση',

  // Form Labels
  'form.name': 'Όνομα',
  'form.email': 'Email',
  'form.country': 'Χώρα',
  'form.amount': 'Ποσό',
  'form.currency': 'Νόμισμα',
  'form.date': 'Ημερομηνία',
  'form.description': 'Περιγραφή',
  'form.notes': 'Σημειώσεις',
  'form.type': 'Τύπος',
  'form.period': 'Περίοδος',
  'form.year': 'Έτος',
  'form.required': 'Υποχρεωτικό',
  'form.optional': 'Προαιρετικό',

  // Table Headers
  'table.fund': 'Ταμείο',
  'table.commitment': 'Δέσμευση',
  'table.called': 'Κληθέν',
  'table.distributed': 'Διανεμηθέν',
  'table.tvpi': 'TVPI',
  'table.status': 'Κατάσταση',
  'table.regulation': 'Κανονισμός',
  'table.filingType': 'Τύπος υποβολής',
  'table.reportingPeriod': 'Περίοδος',
  'table.createdAt': 'Δημιουργήθηκε',
  'table.actions': 'Ενέργειες',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Ταξινομία ΕΕ',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Πληρότητα δεδομένων',
  'compliance.nextDeadline': 'Επόμενη προθεσμία',

  // Reports
  'report.quarterly': 'Τριμηνιαία αναφορά',
  'report.annual': 'Ετήσια αναφορά',
  'report.paiStatement': 'PAI Δήλωση',
  'report.taxonomyReport': 'Αναφορά ταξινομίας',
  'report.generatedAt': 'Δημιουργήθηκε',
  'report.version': 'Έκδοση',

  // General
  'general.loading': 'Φόρτωση...',
  'general.noData': 'Δεν υπάρχουν διαθέσιμα δεδομένα',
  'general.error': 'Παρουσιάστηκε σφάλμα',
  'general.retry': 'Δοκιμάστε ξανά',
  'general.total': 'Σύνολο',
  'general.page': 'Σελίδα',
  'general.of': 'από',
  'general.showing': 'Εμφάνιση',
  'general.results': 'αποτελέσματα',
  'general.language': 'Γλώσσα',
  'general.english': 'Αγγλικά',
  'general.french': 'Γαλλικά',

  // Tour
  'tour.takeTour': 'Ξεκινήστε την ξενάγηση',
  'tour.skip': 'Παράλειψη',
  'tour.next': 'Επόμενο',
  'tour.prev': 'Προηγούμενο',
  'tour.finish': 'Τέλος',
};
